import React, {useState, useEffect, useMemo} from 'react';
import {
    Button, InputGroup, InputGroupText,
    Card,Badge,Spinner,Collapse,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Form,
    Input,
    Row,
    Col,
    Container,
  } from "reactstrap";
  import ReactTable from "components/ReactTable/ReactTable.js";
  
function Vehicles(props) {
    const [list , setList ] = useState([])

      useEffect(() => {
        setList(props.filterbyt.value === "" ? props.vehicleList : props.vehicleList.filter(m => m.categoryCode === props.filterbyt.value) )
      },[props.filterbyt, props.vehicleList])


    const returnvlist = () => {
        try{
         
              return (
                <Card>
                
                <CardBody>
                  <ReactTable
                    data= {list}
                    columns={[
                      {
                          Header: "img",
                          accessor: d =>  <center><img alt="..." width={"40px"} src={`${d.blogo}`} style={{ cursor : "pointer"}} /> </center>,
                        },
                      {
                        Header: "C.Name",
                        accessor: d =>  d.categoryName,
                      },
                     
                      {
                        Header: "Brand",
                        accessor: d => d.brandName,
                      },
                      {
                          Header: "Model",
                          accessor: d =>  d.modelName,
                        },
                      
                       
                       
                     
                      {
                        Header: "Actions",
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                      },
                    ]}
                    /*
                        You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                      */
                    className="-striped -highlight primary-pagination"
                  />
                </CardBody>
              </Card>
              )  
        }catch(e){
           // console.log(e)
        }
       }
    
   

    return (
        <div>
           
              <Row>
                    <Col>     <h6>Create New  
                    <i className="fa fa-filter" aria-hidden="true" style={{paddingLeft : 20, cursor : "pointer", color : "blue"}} onClick={props.toggle}></i> 
                      <span style={{float : "right"}}> 
                    
                    <i className="fa fa-exchange" aria-hidden="true" style={{paddingRight : 20, cursor : "pointer"}} onClick={x => {props.mylisting(); props.setListswap(!props.listswap); }}></i>{' '}<i className="fa fa-refresh" aria-hidden="true" style={{float : "right", cursor : "pointer", marginTop : 2}} onClick={f => {props.populatebrands()}}/></span></h6>
                    
                    <Collapse isOpen={props.isOpen}>
                    <Card>
                      <CardBody>
                        {props.filtercontrol()}
                      </CardBody>
                    </Card>
                  </Collapse>
                    
                    </Col>
              </Row>
              <div className="content">
               {returnvlist()}
              </div>     
        </div>
    );
}

export default Vehicles;